if(window.location.search != '') {
	var locationQueryParams = window.location.search;
}

customElements.define('collection-filters-form', class CollectionFiltersForm extends HTMLElement {
	constructor() {
		super();

		this.querySelector('form').addEventListener('input', this.onSubmitHandler.bind(this));
	}

	onSubmitHandler(event) {
		event.preventDefault();

		const formData = new FormData(event.target.closest('form'));
		const searchParams = new URLSearchParams(formData).toString();
		this.renderPage(searchParams, event);
	}

	renderPage(searchParams, event, updateURLHash = true) {
		const sections = CollectionFiltersForm.getSections();

		sections.forEach((section) => {
			if(window.location.search != '') {
				searchParams = locationQueryParams + '&' + searchParams;
				searchParams = searchParams.replace('?','')
			}
			const sectionUrl = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const newUrl = `${window.location.pathname}?${searchParams}`;
			this.renderSectionFromFetch(sectionUrl, newUrl, event);
		})
	}

	renderSectionFromFetch(sectionUrl, newUrl, event) {
		fetch(sectionUrl)
			.then(response => response.text())
			.then((responseText) => {
				const newHTML = new DOMParser().parseFromString(responseText, 'text/html').getElementById('CollectionProductGrid').innerHTML;				
				document.getElementById('CollectionProductGrid').innerHTML = newHTML;
				window.history.replaceState({ }, '', newUrl);
                setTimeout(() => {
                  var element = document.querySelectorAll(".trustpilot-widget");
                  for(var i=0; i<element.length; i++) {
                      window.Trustpilot.loadFromElement(element[i]);
                  }
                }, 1000)
				initAjaxinate();
			})
	}

	static getSections() {
		return [
			{
				section: document.getElementById('CollectionProductGrid').dataset.id,
			}
		]
	}
});